<div class="breadcrumb-bar">
  <div class="breadcrumb">
    <span class="breadcrumb-current">Master</span>
  </div>
</div>

<main class="page-content">
  <section class="content-card">
    <h1 class="page-title">{{ pageTitle }}</h1>
    <p class="page-copy">Use master data and reference setups to support review operations.</p>
  </section>
</main>
